import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltCommentDialogThreadCardReactionPin = function (props) {
    var children = props.children, reactionId = props.reactionId, remainingProps = __rest(props, ["children", "reactionId"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-reaction-pin-wireframe", __assign({}, transformedProps, { "reaction-id": reactionId }), children));
};
export default VeltCommentDialogThreadCardReactionPin;
